// Auto-generated by @vm0/firewalls-generator.
// Regenerate: cd turbo && pnpm -F @vm0/firewalls-generator generate
//
// DO NOT EDIT THIS FILE MANUALLY.
import type { FirewallRoutingMetadata } from "./types";

const FIREWALL_ROUTING_METADATA_LOADERS: Readonly<
  Record<string, () => Promise<FirewallRoutingMetadata>>
> = Object.assign(Object.create(null), {
  ["adzuna"]: async () => {
    return (await import("./routing-details/adzuna.generated" as string))["firewallRoutingMetadata"];
  },
  ["agentmail"]: async () => {
    return (await import("./routing-details/agentmail.generated" as string))["firewallRoutingMetadata"];
  },
  ["agora"]: async () => {
    return (await import("./routing-details/agora.generated" as string))["firewallRoutingMetadata"];
  },
  ["ahrefs"]: async () => {
    return (await import("./routing-details/ahrefs.generated" as string))["firewallRoutingMetadata"];
  },
  ["airtable"]: async () => {
    return (await import("./routing-details/airtable.generated" as string))["firewallRoutingMetadata"];
  },
  ["alchemy"]: async () => {
    return (await import("./routing-details/alchemy.generated" as string))["firewallRoutingMetadata"];
  },
  ["altium-365"]: async () => {
    return (await import("./routing-details/altium-365.generated" as string))["firewallRoutingMetadata"];
  },
  ["amadeus"]: async () => {
    return (await import("./routing-details/amadeus.generated" as string))["firewallRoutingMetadata"];
  },
  ["amplitude"]: async () => {
    return (await import("./routing-details/amplitude.generated" as string))["firewallRoutingMetadata"];
  },
  ["anthropic-managed-agents"]: async () => {
    return (await import("./routing-details/anthropic-managed-agents.generated" as string))["firewallRoutingMetadata"];
  },
  ["apify"]: async () => {
    return (await import("./routing-details/apify.generated" as string))["firewallRoutingMetadata"];
  },
  ["apollo"]: async () => {
    return (await import("./routing-details/apollo.generated" as string))["firewallRoutingMetadata"];
  },
  ["asana"]: async () => {
    return (await import("./routing-details/asana.generated" as string))["firewallRoutingMetadata"];
  },
  ["ashby"]: async () => {
    return (await import("./routing-details/ashby.generated" as string))["firewallRoutingMetadata"];
  },
  ["atlascloud"]: async () => {
    return (await import("./routing-details/atlascloud.generated" as string))["firewallRoutingMetadata"];
  },
  ["atlassian"]: async () => {
    return (await import("./routing-details/atlassian.generated" as string))["firewallRoutingMetadata"];
  },
  ["attio"]: async () => {
    return (await import("./routing-details/attio.generated" as string))["firewallRoutingMetadata"];
  },
  ["aviationstack"]: async () => {
    return (await import("./routing-details/aviationstack.generated" as string))["firewallRoutingMetadata"];
  },
  ["aws"]: async () => {
    return (await import("./routing-details/aws.generated" as string))["firewallRoutingMetadata"];
  },
  ["axiom"]: async () => {
    return (await import("./routing-details/axiom.generated" as string))["firewallRoutingMetadata"];
  },
  ["base44"]: async () => {
    return (await import("./routing-details/base44.generated" as string))["firewallRoutingMetadata"];
  },
  ["bentoml"]: async () => {
    return (await import("./routing-details/bentoml.generated" as string))["firewallRoutingMetadata"];
  },
  ["bfl"]: async () => {
    return (await import("./routing-details/bfl.generated" as string))["firewallRoutingMetadata"];
  },
  ["bitrefill"]: async () => {
    return (await import("./routing-details/bitrefill.generated" as string))["firewallRoutingMetadata"];
  },
  ["bitrix"]: async () => {
    return (await import("./routing-details/bitrix.generated" as string))["firewallRoutingMetadata"];
  },
  ["bland"]: async () => {
    return (await import("./routing-details/bland.generated" as string))["firewallRoutingMetadata"];
  },
  ["box"]: async () => {
    return (await import("./routing-details/box.generated" as string))["firewallRoutingMetadata"];
  },
  ["brave-search"]: async () => {
    return (await import("./routing-details/brave-search.generated" as string))["firewallRoutingMetadata"];
  },
  ["brevo"]: async () => {
    return (await import("./routing-details/brevo.generated" as string))["firewallRoutingMetadata"];
  },
  ["brex"]: async () => {
    return (await import("./routing-details/brex.generated" as string))["firewallRoutingMetadata"];
  },
  ["bright-data"]: async () => {
    return (await import("./routing-details/bright-data.generated" as string))["firewallRoutingMetadata"];
  },
  ["browser-use"]: async () => {
    return (await import("./routing-details/browser-use.generated" as string))["firewallRoutingMetadata"];
  },
  ["browserbase"]: async () => {
    return (await import("./routing-details/browserbase.generated" as string))["firewallRoutingMetadata"];
  },
  ["browserless"]: async () => {
    return (await import("./routing-details/browserless.generated" as string))["firewallRoutingMetadata"];
  },
  ["browserstack"]: async () => {
    return (await import("./routing-details/browserstack.generated" as string))["firewallRoutingMetadata"];
  },
  ["bubblemaps"]: async () => {
    return (await import("./routing-details/bubblemaps.generated" as string))["firewallRoutingMetadata"];
  },
  ["buffer"]: async () => {
    return (await import("./routing-details/buffer.generated" as string))["firewallRoutingMetadata"];
  },
  ["builtwith"]: async () => {
    return (await import("./routing-details/builtwith.generated" as string))["firewallRoutingMetadata"];
  },
  ["cal-com"]: async () => {
    return (await import("./routing-details/cal-com.generated" as string))["firewallRoutingMetadata"];
  },
  ["calendly"]: async () => {
    return (await import("./routing-details/calendly.generated" as string))["firewallRoutingMetadata"];
  },
  ["canva"]: async () => {
    return (await import("./routing-details/canva.generated" as string))["firewallRoutingMetadata"];
  },
  ["chatwoot"]: async () => {
    return (await import("./routing-details/chatwoot.generated" as string))["firewallRoutingMetadata"];
  },
  ["checkr"]: async () => {
    return (await import("./routing-details/checkr.generated" as string))["firewallRoutingMetadata"];
  },
  ["clado"]: async () => {
    return (await import("./routing-details/clado.generated" as string))["firewallRoutingMetadata"];
  },
  ["clearbit"]: async () => {
    return (await import("./routing-details/clearbit.generated" as string))["firewallRoutingMetadata"];
  },
  ["clerk"]: async () => {
    return (await import("./routing-details/clerk.generated" as string))["firewallRoutingMetadata"];
  },
  ["clickup"]: async () => {
    return (await import("./routing-details/clickup.generated" as string))["firewallRoutingMetadata"];
  },
  ["close"]: async () => {
    return (await import("./routing-details/close.generated" as string))["firewallRoutingMetadata"];
  },
  ["cloudflare"]: async () => {
    return (await import("./routing-details/cloudflare.generated" as string))["firewallRoutingMetadata"];
  },
  ["coda"]: async () => {
    return (await import("./routing-details/coda.generated" as string))["firewallRoutingMetadata"];
  },
  ["coingecko"]: async () => {
    return (await import("./routing-details/coingecko.generated" as string))["firewallRoutingMetadata"];
  },
  ["coresignal"]: async () => {
    return (await import("./routing-details/coresignal.generated" as string))["firewallRoutingMetadata"];
  },
  ["cronlytic"]: async () => {
    return (await import("./routing-details/cronlytic.generated" as string))["firewallRoutingMetadata"];
  },
  ["crustdata"]: async () => {
    return (await import("./routing-details/crustdata.generated" as string))["firewallRoutingMetadata"];
  },
  ["cursor"]: async () => {
    return (await import("./routing-details/cursor.generated" as string))["firewallRoutingMetadata"];
  },
  ["customer-io"]: async () => {
    return (await import("./routing-details/customer-io.generated" as string))["firewallRoutingMetadata"];
  },
  ["daytona"]: async () => {
    return (await import("./routing-details/daytona.generated" as string))["firewallRoutingMetadata"];
  },
  ["db9"]: async () => {
    return (await import("./routing-details/db9.generated" as string))["firewallRoutingMetadata"];
  },
  ["deel"]: async () => {
    return (await import("./routing-details/deel.generated" as string))["firewallRoutingMetadata"];
  },
  ["deepseek"]: async () => {
    return (await import("./routing-details/deepseek.generated" as string))["firewallRoutingMetadata"];
  },
  ["defillama"]: async () => {
    return (await import("./routing-details/defillama.generated" as string))["firewallRoutingMetadata"];
  },
  ["devto"]: async () => {
    return (await import("./routing-details/devto.generated" as string))["firewallRoutingMetadata"];
  },
  ["diffbot"]: async () => {
    return (await import("./routing-details/diffbot.generated" as string))["firewallRoutingMetadata"];
  },
  ["dify"]: async () => {
    return (await import("./routing-details/dify.generated" as string))["firewallRoutingMetadata"];
  },
  ["discord"]: async () => {
    return (await import("./routing-details/discord.generated" as string))["firewallRoutingMetadata"];
  },
  ["discord-webhook"]: async () => {
    return (await import("./routing-details/discord-webhook.generated" as string))["firewallRoutingMetadata"];
  },
  ["docusign"]: async () => {
    return (await import("./routing-details/docusign.generated" as string))["firewallRoutingMetadata"];
  },
  ["doppler"]: async () => {
    return (await import("./routing-details/doppler.generated" as string))["firewallRoutingMetadata"];
  },
  ["doubao"]: async () => {
    return (await import("./routing-details/doubao.generated" as string))["firewallRoutingMetadata"];
  },
  ["drive9"]: async () => {
    return (await import("./routing-details/drive9.generated" as string))["firewallRoutingMetadata"];
  },
  ["dropbox"]: async () => {
    return (await import("./routing-details/dropbox.generated" as string))["firewallRoutingMetadata"];
  },
  ["dropbox-sign"]: async () => {
    return (await import("./routing-details/dropbox-sign.generated" as string))["firewallRoutingMetadata"];
  },
  ["duffel"]: async () => {
    return (await import("./routing-details/duffel.generated" as string))["firewallRoutingMetadata"];
  },
  ["e2b"]: async () => {
    return (await import("./routing-details/e2b.generated" as string))["firewallRoutingMetadata"];
  },
  ["elevenlabs"]: async () => {
    return (await import("./routing-details/elevenlabs.generated" as string))["firewallRoutingMetadata"];
  },
  ["etherscan"]: async () => {
    return (await import("./routing-details/etherscan.generated" as string))["firewallRoutingMetadata"];
  },
  ["etsy"]: async () => {
    return (await import("./routing-details/etsy.generated" as string))["firewallRoutingMetadata"];
  },
  ["exa"]: async () => {
    return (await import("./routing-details/exa.generated" as string))["firewallRoutingMetadata"];
  },
  ["explorium"]: async () => {
    return (await import("./routing-details/explorium.generated" as string))["firewallRoutingMetadata"];
  },
  ["faire"]: async () => {
    return (await import("./routing-details/faire.generated" as string))["firewallRoutingMetadata"];
  },
  ["fal"]: async () => {
    return (await import("./routing-details/fal.generated" as string))["firewallRoutingMetadata"];
  },
  ["figma"]: async () => {
    return (await import("./routing-details/figma.generated" as string))["firewallRoutingMetadata"];
  },
  ["firecrawl"]: async () => {
    return (await import("./routing-details/firecrawl.generated" as string))["firewallRoutingMetadata"];
  },
  ["fireflies"]: async () => {
    return (await import("./routing-details/fireflies.generated" as string))["firewallRoutingMetadata"];
  },
  ["flightaware"]: async () => {
    return (await import("./routing-details/flightaware.generated" as string))["firewallRoutingMetadata"];
  },
  ["freshdesk"]: async () => {
    return (await import("./routing-details/freshdesk.generated" as string))["firewallRoutingMetadata"];
  },
  ["gamma"]: async () => {
    return (await import("./routing-details/gamma.generated" as string))["firewallRoutingMetadata"];
  },
  ["garmin-connect"]: async () => {
    return (await import("./routing-details/garmin-connect.generated" as string))["firewallRoutingMetadata"];
  },
  ["gemini"]: async () => {
    return (await import("./routing-details/gemini.generated" as string))["firewallRoutingMetadata"];
  },
  ["github"]: async () => {
    return (await import("./routing-details/github.generated" as string))["firewallRoutingMetadata"];
  },
  ["gitlab"]: async () => {
    return (await import("./routing-details/gitlab.generated" as string))["firewallRoutingMetadata"];
  },
  ["gmail"]: async () => {
    return (await import("./routing-details/gmail.generated" as string))["firewallRoutingMetadata"];
  },
  ["gong"]: async () => {
    return (await import("./routing-details/gong.generated" as string))["firewallRoutingMetadata"];
  },
  ["google-ads"]: async () => {
    return (await import("./routing-details/google-ads.generated" as string))["firewallRoutingMetadata"];
  },
  ["google-analytics"]: async () => {
    return (await import("./routing-details/google-analytics.generated" as string))["firewallRoutingMetadata"];
  },
  ["google-calendar"]: async () => {
    return (await import("./routing-details/google-calendar.generated" as string))["firewallRoutingMetadata"];
  },
  ["google-cloud"]: async () => {
    return (await import("./routing-details/google-cloud.generated" as string))["firewallRoutingMetadata"];
  },
  ["google-docs"]: async () => {
    return (await import("./routing-details/google-docs.generated" as string))["firewallRoutingMetadata"];
  },
  ["google-drive"]: async () => {
    return (await import("./routing-details/google-drive.generated" as string))["firewallRoutingMetadata"];
  },
  ["google-maps"]: async () => {
    return (await import("./routing-details/google-maps.generated" as string))["firewallRoutingMetadata"];
  },
  ["google-meet"]: async () => {
    return (await import("./routing-details/google-meet.generated" as string))["firewallRoutingMetadata"];
  },
  ["google-search-console"]: async () => {
    return (await import("./routing-details/google-search-console.generated" as string))["firewallRoutingMetadata"];
  },
  ["google-sheets"]: async () => {
    return (await import("./routing-details/google-sheets.generated" as string))["firewallRoutingMetadata"];
  },
  ["granola"]: async () => {
    return (await import("./routing-details/granola.generated" as string))["firewallRoutingMetadata"];
  },
  ["greenhouse"]: async () => {
    return (await import("./routing-details/greenhouse.generated" as string))["firewallRoutingMetadata"];
  },
  ["groq"]: async () => {
    return (await import("./routing-details/groq.generated" as string))["firewallRoutingMetadata"];
  },
  ["gumroad"]: async () => {
    return (await import("./routing-details/gumroad.generated" as string))["firewallRoutingMetadata"];
  },
  ["helicone"]: async () => {
    return (await import("./routing-details/helicone.generated" as string))["firewallRoutingMetadata"];
  },
  ["heygen"]: async () => {
    return (await import("./routing-details/heygen.generated" as string))["firewallRoutingMetadata"];
  },
  ["hitem3d"]: async () => {
    return (await import("./routing-details/hitem3d.generated" as string))["firewallRoutingMetadata"];
  },
  ["honcho"]: async () => {
    return (await import("./routing-details/honcho.generated" as string))["firewallRoutingMetadata"];
  },
  ["htmlcsstoimage"]: async () => {
    return (await import("./routing-details/htmlcsstoimage.generated" as string))["firewallRoutingMetadata"];
  },
  ["hubspot"]: async () => {
    return (await import("./routing-details/hubspot.generated" as string))["firewallRoutingMetadata"];
  },
  ["hugging-face"]: async () => {
    return (await import("./routing-details/hugging-face.generated" as string))["firewallRoutingMetadata"];
  },
  ["hume"]: async () => {
    return (await import("./routing-details/hume.generated" as string))["firewallRoutingMetadata"];
  },
  ["hunter"]: async () => {
    return (await import("./routing-details/hunter.generated" as string))["firewallRoutingMetadata"];
  },
  ["imgur"]: async () => {
    return (await import("./routing-details/imgur.generated" as string))["firewallRoutingMetadata"];
  },
  ["infisical"]: async () => {
    return (await import("./routing-details/infisical.generated" as string))["firewallRoutingMetadata"];
  },
  ["insforge"]: async () => {
    return (await import("./routing-details/insforge.generated" as string))["firewallRoutingMetadata"];
  },
  ["instagram"]: async () => {
    return (await import("./routing-details/instagram.generated" as string))["firewallRoutingMetadata"];
  },
  ["instantly"]: async () => {
    return (await import("./routing-details/instantly.generated" as string))["firewallRoutingMetadata"];
  },
  ["intercom"]: async () => {
    return (await import("./routing-details/intercom.generated" as string))["firewallRoutingMetadata"];
  },
  ["intervals-icu"]: async () => {
    return (await import("./routing-details/intervals-icu.generated" as string))["firewallRoutingMetadata"];
  },
  ["ironclad"]: async () => {
    return (await import("./routing-details/ironclad.generated" as string))["firewallRoutingMetadata"];
  },
  ["jam"]: async () => {
    return (await import("./routing-details/jam.generated" as string))["firewallRoutingMetadata"];
  },
  ["jira"]: async () => {
    return (await import("./routing-details/jira.generated" as string))["firewallRoutingMetadata"];
  },
  ["jotform"]: async () => {
    return (await import("./routing-details/jotform.generated" as string))["firewallRoutingMetadata"];
  },
  ["klaviyo"]: async () => {
    return (await import("./routing-details/klaviyo.generated" as string))["firewallRoutingMetadata"];
  },
  ["kommo"]: async () => {
    return (await import("./routing-details/kommo.generated" as string))["firewallRoutingMetadata"];
  },
  ["langfuse"]: async () => {
    return (await import("./routing-details/langfuse.generated" as string))["firewallRoutingMetadata"];
  },
  ["langsmith"]: async () => {
    return (await import("./routing-details/langsmith.generated" as string))["firewallRoutingMetadata"];
  },
  ["lark"]: async () => {
    return (await import("./routing-details/lark.generated" as string))["firewallRoutingMetadata"];
  },
  ["line"]: async () => {
    return (await import("./routing-details/line.generated" as string))["firewallRoutingMetadata"];
  },
  ["linear"]: async () => {
    return (await import("./routing-details/linear.generated" as string))["firewallRoutingMetadata"];
  },
  ["loops"]: async () => {
    return (await import("./routing-details/loops.generated" as string))["firewallRoutingMetadata"];
  },
  ["luma"]: async () => {
    return (await import("./routing-details/luma.generated" as string))["firewallRoutingMetadata"];
  },
  ["luma-ai"]: async () => {
    return (await import("./routing-details/luma-ai.generated" as string))["firewallRoutingMetadata"];
  },
  ["mailchimp"]: async () => {
    return (await import("./routing-details/mailchimp.generated" as string))["firewallRoutingMetadata"];
  },
  ["mailsac"]: async () => {
    return (await import("./routing-details/mailsac.generated" as string))["firewallRoutingMetadata"];
  },
  ["make"]: async () => {
    return (await import("./routing-details/make.generated" as string))["firewallRoutingMetadata"];
  },
  ["manus"]: async () => {
    return (await import("./routing-details/manus.generated" as string))["firewallRoutingMetadata"];
  },
  ["mapbox"]: async () => {
    return (await import("./routing-details/mapbox.generated" as string))["firewallRoutingMetadata"];
  },
  ["maskdb"]: async () => {
    return (await import("./routing-details/maskdb.generated" as string))["firewallRoutingMetadata"];
  },
  ["massive"]: async () => {
    return (await import("./routing-details/massive.generated" as string))["firewallRoutingMetadata"];
  },
  ["mathpix"]: async () => {
    return (await import("./routing-details/mathpix.generated" as string))["firewallRoutingMetadata"];
  },
  ["mem0"]: async () => {
    return (await import("./routing-details/mem0.generated" as string))["firewallRoutingMetadata"];
  },
  ["mercury"]: async () => {
    return (await import("./routing-details/mercury.generated" as string))["firewallRoutingMetadata"];
  },
  ["meshy"]: async () => {
    return (await import("./routing-details/meshy.generated" as string))["firewallRoutingMetadata"];
  },
  ["meta-ads"]: async () => {
    return (await import("./routing-details/meta-ads.generated" as string))["firewallRoutingMetadata"];
  },
  ["metabase"]: async () => {
    return (await import("./routing-details/metabase.generated" as string))["firewallRoutingMetadata"];
  },
  ["microsoft-365"]: async () => {
    return (await import("./routing-details/microsoft-365.generated" as string))["firewallRoutingMetadata"];
  },
  ["minimax"]: async () => {
    return (await import("./routing-details/minimax.generated" as string))["firewallRoutingMetadata"];
  },
  ["miro"]: async () => {
    return (await import("./routing-details/miro.generated" as string))["firewallRoutingMetadata"];
  },
  ["mixpanel"]: async () => {
    return (await import("./routing-details/mixpanel.generated" as string))["firewallRoutingMetadata"];
  },
  ["modal"]: async () => {
    return (await import("./routing-details/modal.generated" as string))["firewallRoutingMetadata"];
  },
  ["monday"]: async () => {
    return (await import("./routing-details/monday.generated" as string))["firewallRoutingMetadata"];
  },
  ["moss"]: async () => {
    return (await import("./routing-details/moss.generated" as string))["firewallRoutingMetadata"];
  },
  ["msg9"]: async () => {
    return (await import("./routing-details/msg9.generated" as string))["firewallRoutingMetadata"];
  },
  ["n8n"]: async () => {
    return (await import("./routing-details/n8n.generated" as string))["firewallRoutingMetadata"];
  },
  ["neon"]: async () => {
    return (await import("./routing-details/neon.generated" as string))["firewallRoutingMetadata"];
  },
  ["netdata"]: async () => {
    return (await import("./routing-details/netdata.generated" as string))["firewallRoutingMetadata"];
  },
  ["notion"]: async () => {
    return (await import("./routing-details/notion.generated" as string))["firewallRoutingMetadata"];
  },
  ["novita"]: async () => {
    return (await import("./routing-details/novita.generated" as string))["firewallRoutingMetadata"];
  },
  ["nyne"]: async () => {
    return (await import("./routing-details/nyne.generated" as string))["firewallRoutingMetadata"];
  },
  ["onyx"]: async () => {
    return (await import("./routing-details/onyx.generated" as string))["firewallRoutingMetadata"];
  },
  ["openai"]: async () => {
    return (await import("./routing-details/openai.generated" as string))["firewallRoutingMetadata"];
  },
  ["openrouter"]: async () => {
    return (await import("./routing-details/openrouter.generated" as string))["firewallRoutingMetadata"];
  },
  ["openweather"]: async () => {
    return (await import("./routing-details/openweather.generated" as string))["firewallRoutingMetadata"];
  },
  ["outlook-calendar"]: async () => {
    return (await import("./routing-details/outlook-calendar.generated" as string))["firewallRoutingMetadata"];
  },
  ["outlook-mail"]: async () => {
    return (await import("./routing-details/outlook-mail.generated" as string))["firewallRoutingMetadata"];
  },
  ["pandadoc"]: async () => {
    return (await import("./routing-details/pandadoc.generated" as string))["firewallRoutingMetadata"];
  },
  ["parallel"]: async () => {
    return (await import("./routing-details/parallel.generated" as string))["firewallRoutingMetadata"];
  },
  ["pdf4me"]: async () => {
    return (await import("./routing-details/pdf4me.generated" as string))["firewallRoutingMetadata"];
  },
  ["pdfco"]: async () => {
    return (await import("./routing-details/pdfco.generated" as string))["firewallRoutingMetadata"];
  },
  ["pdforge"]: async () => {
    return (await import("./routing-details/pdforge.generated" as string))["firewallRoutingMetadata"];
  },
  ["people-data-labs"]: async () => {
    return (await import("./routing-details/people-data-labs.generated" as string))["firewallRoutingMetadata"];
  },
  ["perplexity"]: async () => {
    return (await import("./routing-details/perplexity.generated" as string))["firewallRoutingMetadata"];
  },
  ["pexels"]: async () => {
    return (await import("./routing-details/pexels.generated" as string))["firewallRoutingMetadata"];
  },
  ["pika"]: async () => {
    return (await import("./routing-details/pika.generated" as string))["firewallRoutingMetadata"];
  },
  ["pinecone"]: async () => {
    return (await import("./routing-details/pinecone.generated" as string))["firewallRoutingMetadata"];
  },
  ["pipedream"]: async () => {
    return (await import("./routing-details/pipedream.generated" as string))["firewallRoutingMetadata"];
  },
  ["pipedrive"]: async () => {
    return (await import("./routing-details/pipedrive.generated" as string))["firewallRoutingMetadata"];
  },
  ["plain"]: async () => {
    return (await import("./routing-details/plain.generated" as string))["firewallRoutingMetadata"];
  },
  ["plausible"]: async () => {
    return (await import("./routing-details/plausible.generated" as string))["firewallRoutingMetadata"];
  },
  ["playstation"]: async () => {
    return (await import("./routing-details/playstation.generated" as string))["firewallRoutingMetadata"];
  },
  ["podchaser"]: async () => {
    return (await import("./routing-details/podchaser.generated" as string))["firewallRoutingMetadata"];
  },
  ["porkbun"]: async () => {
    return (await import("./routing-details/porkbun.generated" as string))["firewallRoutingMetadata"];
  },
  ["posthog"]: async () => {
    return (await import("./routing-details/posthog.generated" as string))["firewallRoutingMetadata"];
  },
  ["printful"]: async () => {
    return (await import("./routing-details/printful.generated" as string))["firewallRoutingMetadata"];
  },
  ["prisma-postgres"]: async () => {
    return (await import("./routing-details/prisma-postgres.generated" as string))["firewallRoutingMetadata"];
  },
  ["productlane"]: async () => {
    return (await import("./routing-details/productlane.generated" as string))["firewallRoutingMetadata"];
  },
  ["profound"]: async () => {
    return (await import("./routing-details/profound.generated" as string))["firewallRoutingMetadata"];
  },
  ["pushinator"]: async () => {
    return (await import("./routing-details/pushinator.generated" as string))["firewallRoutingMetadata"];
  },
  ["qdrant"]: async () => {
    return (await import("./routing-details/qdrant.generated" as string))["firewallRoutingMetadata"];
  },
  ["qiita"]: async () => {
    return (await import("./routing-details/qiita.generated" as string))["firewallRoutingMetadata"];
  },
  ["quickbooks"]: async () => {
    return (await import("./routing-details/quickbooks.generated" as string))["firewallRoutingMetadata"];
  },
  ["railway"]: async () => {
    return (await import("./routing-details/railway.generated" as string))["firewallRoutingMetadata"];
  },
  ["railway-project"]: async () => {
    return (await import("./routing-details/railway-project.generated" as string))["firewallRoutingMetadata"];
  },
  ["reap"]: async () => {
    return (await import("./routing-details/reap.generated" as string))["firewallRoutingMetadata"];
  },
  ["recraft"]: async () => {
    return (await import("./routing-details/recraft.generated" as string))["firewallRoutingMetadata"];
  },
  ["reddit"]: async () => {
    return (await import("./routing-details/reddit.generated" as string))["firewallRoutingMetadata"];
  },
  ["reducto"]: async () => {
    return (await import("./routing-details/reducto.generated" as string))["firewallRoutingMetadata"];
  },
  ["render"]: async () => {
    return (await import("./routing-details/render.generated" as string))["firewallRoutingMetadata"];
  },
  ["rentcast"]: async () => {
    return (await import("./routing-details/rentcast.generated" as string))["firewallRoutingMetadata"];
  },
  ["replicate"]: async () => {
    return (await import("./routing-details/replicate.generated" as string))["firewallRoutingMetadata"];
  },
  ["reportei"]: async () => {
    return (await import("./routing-details/reportei.generated" as string))["firewallRoutingMetadata"];
  },
  ["resend"]: async () => {
    return (await import("./routing-details/resend.generated" as string))["firewallRoutingMetadata"];
  },
  ["revenuecat"]: async () => {
    return (await import("./routing-details/revenuecat.generated" as string))["firewallRoutingMetadata"];
  },
  ["runway"]: async () => {
    return (await import("./routing-details/runway.generated" as string))["firewallRoutingMetadata"];
  },
  ["salesforce"]: async () => {
    return (await import("./routing-details/salesforce.generated" as string))["firewallRoutingMetadata"];
  },
  ["scrapeninja"]: async () => {
    return (await import("./routing-details/scrapeninja.generated" as string))["firewallRoutingMetadata"];
  },
  ["segment"]: async () => {
    return (await import("./routing-details/segment.generated" as string))["firewallRoutingMetadata"];
  },
  ["semrush"]: async () => {
    return (await import("./routing-details/semrush.generated" as string))["firewallRoutingMetadata"];
  },
  ["sendgrid"]: async () => {
    return (await import("./routing-details/sendgrid.generated" as string))["firewallRoutingMetadata"];
  },
  ["sentry"]: async () => {
    return (await import("./routing-details/sentry.generated" as string))["firewallRoutingMetadata"];
  },
  ["serpapi"]: async () => {
    return (await import("./routing-details/serpapi.generated" as string))["firewallRoutingMetadata"];
  },
  ["servicenow"]: async () => {
    return (await import("./routing-details/servicenow.generated" as string))["firewallRoutingMetadata"];
  },
  ["shopify"]: async () => {
    return (await import("./routing-details/shopify.generated" as string))["firewallRoutingMetadata"];
  },
  ["shortio"]: async () => {
    return (await import("./routing-details/shortio.generated" as string))["firewallRoutingMetadata"];
  },
  ["similarweb"]: async () => {
    return (await import("./routing-details/similarweb.generated" as string))["firewallRoutingMetadata"];
  },
  ["slack"]: async () => {
    return (await import("./routing-details/slack.generated" as string))["firewallRoutingMetadata"];
  },
  ["slack-webhook"]: async () => {
    return (await import("./routing-details/slack-webhook.generated" as string))["firewallRoutingMetadata"];
  },
  ["slock"]: async () => {
    return (await import("./routing-details/slock.generated" as string))["firewallRoutingMetadata"];
  },
  ["snowflake"]: async () => {
    return (await import("./routing-details/snowflake.generated" as string))["firewallRoutingMetadata"];
  },
  ["sociavault"]: async () => {
    return (await import("./routing-details/sociavault.generated" as string))["firewallRoutingMetadata"];
  },
  ["sponge"]: async () => {
    return (await import("./routing-details/sponge.generated" as string))["firewallRoutingMetadata"];
  },
  ["spotify"]: async () => {
    return (await import("./routing-details/spotify.generated" as string))["firewallRoutingMetadata"];
  },
  ["sproutgigs"]: async () => {
    return (await import("./routing-details/sproutgigs.generated" as string))["firewallRoutingMetadata"];
  },
  ["square"]: async () => {
    return (await import("./routing-details/square.generated" as string))["firewallRoutingMetadata"];
  },
  ["stability-ai"]: async () => {
    return (await import("./routing-details/stability-ai.generated" as string))["firewallRoutingMetadata"];
  },
  ["steam"]: async () => {
    return (await import("./routing-details/steam.generated" as string))["firewallRoutingMetadata"];
  },
  ["strapi"]: async () => {
    return (await import("./routing-details/strapi.generated" as string))["firewallRoutingMetadata"];
  },
  ["strava"]: async () => {
    return (await import("./routing-details/strava.generated" as string))["firewallRoutingMetadata"];
  },
  ["streak"]: async () => {
    return (await import("./routing-details/streak.generated" as string))["firewallRoutingMetadata"];
  },
  ["stripe"]: async () => {
    return (await import("./routing-details/stripe.generated" as string))["firewallRoutingMetadata"];
  },
  ["supabase"]: async () => {
    return (await import("./routing-details/supabase.generated" as string))["firewallRoutingMetadata"];
  },
  ["supadata"]: async () => {
    return (await import("./routing-details/supadata.generated" as string))["firewallRoutingMetadata"];
  },
  ["supermemory"]: async () => {
    return (await import("./routing-details/supermemory.generated" as string))["firewallRoutingMetadata"];
  },
  ["tavily"]: async () => {
    return (await import("./routing-details/tavily.generated" as string))["firewallRoutingMetadata"];
  },
  ["test-oauth"]: async () => {
    return (await import("./routing-details/test-oauth.generated" as string))["firewallRoutingMetadata"];
  },
  ["testrail"]: async () => {
    return (await import("./routing-details/testrail.generated" as string))["firewallRoutingMetadata"];
  },
  ["ticketmaster"]: async () => {
    return (await import("./routing-details/ticketmaster.generated" as string))["firewallRoutingMetadata"];
  },
  ["tiktok-ads"]: async () => {
    return (await import("./routing-details/tiktok-ads.generated" as string))["firewallRoutingMetadata"];
  },
  ["tldv"]: async () => {
    return (await import("./routing-details/tldv.generated" as string))["firewallRoutingMetadata"];
  },
  ["todoist"]: async () => {
    return (await import("./routing-details/todoist.generated" as string))["firewallRoutingMetadata"];
  },
  ["together"]: async () => {
    return (await import("./routing-details/together.generated" as string))["firewallRoutingMetadata"];
  },
  ["tripo"]: async () => {
    return (await import("./routing-details/tripo.generated" as string))["firewallRoutingMetadata"];
  },
  ["twenty"]: async () => {
    return (await import("./routing-details/twenty.generated" as string))["firewallRoutingMetadata"];
  },
  ["twilio"]: async () => {
    return (await import("./routing-details/twilio.generated" as string))["firewallRoutingMetadata"];
  },
  ["typeform"]: async () => {
    return (await import("./routing-details/typeform.generated" as string))["firewallRoutingMetadata"];
  },
  ["v0"]: async () => {
    return (await import("./routing-details/v0.generated" as string))["firewallRoutingMetadata"];
  },
  ["vercel"]: async () => {
    return (await import("./routing-details/vercel.generated" as string))["firewallRoutingMetadata"];
  },
  ["wandb"]: async () => {
    return (await import("./routing-details/wandb.generated" as string))["firewallRoutingMetadata"];
  },
  ["webflow"]: async () => {
    return (await import("./routing-details/webflow.generated" as string))["firewallRoutingMetadata"];
  },
  ["weread"]: async () => {
    return (await import("./routing-details/weread.generated" as string))["firewallRoutingMetadata"];
  },
  ["whale-alert"]: async () => {
    return (await import("./routing-details/whale-alert.generated" as string))["firewallRoutingMetadata"];
  },
  ["wix"]: async () => {
    return (await import("./routing-details/wix.generated" as string))["firewallRoutingMetadata"];
  },
  ["workos"]: async () => {
    return (await import("./routing-details/workos.generated" as string))["firewallRoutingMetadata"];
  },
  ["wrike"]: async () => {
    return (await import("./routing-details/wrike.generated" as string))["firewallRoutingMetadata"];
  },
  ["x"]: async () => {
    return (await import("./routing-details/x.generated" as string))["firewallRoutingMetadata"];
  },
  ["xero"]: async () => {
    return (await import("./routing-details/xero.generated" as string))["firewallRoutingMetadata"];
  },
  ["youtube"]: async () => {
    return (await import("./routing-details/youtube.generated" as string))["firewallRoutingMetadata"];
  },
  ["zapier"]: async () => {
    return (await import("./routing-details/zapier.generated" as string))["firewallRoutingMetadata"];
  },
  ["zapsign"]: async () => {
    return (await import("./routing-details/zapsign.generated" as string))["firewallRoutingMetadata"];
  },
  ["zendesk"]: async () => {
    return (await import("./routing-details/zendesk.generated" as string))["firewallRoutingMetadata"];
  },
  ["zep"]: async () => {
    return (await import("./routing-details/zep.generated" as string))["firewallRoutingMetadata"];
  },
  ["zeptomail"]: async () => {
    return (await import("./routing-details/zeptomail.generated" as string))["firewallRoutingMetadata"];
  },
  ["zoom"]: async () => {
    return (await import("./routing-details/zoom.generated" as string))["firewallRoutingMetadata"];
  },
} satisfies Readonly<
  Record<string, () => Promise<FirewallRoutingMetadata>>
>);

export async function loadGeneratedFirewallRoutingMetadata(
  type: string,
): Promise<FirewallRoutingMetadata | null> {
  const load = FIREWALL_ROUTING_METADATA_LOADERS[type];
  if (!load) {
    return null;
  }
  return await load();
}
